import SwipeToDelete from "./SwipeToDelete";

export * from './styles';
export default SwipeToDelete;
